module.exports = __webpack_public_path__ + "0daafcc1ffee168a35c2716720a38ca3.MP3";